<template>

  <div class="memberContainer mx-auto pxXxs15 pxXl0">
    <!-- / -->
    <div v-if="propsSessionExpired" class="errMsgBox mb30 mbMd50">
      <p class="errMsg text-sm-center">セッションが切れました。<br class="d-md-none">お手数ですが再度ログインしてください。</p>
    </div>
    <!-- / -->
    <div v-if="propsLoginFailed" class="errMsgBox mb30 mbMd50">
      <p class="errMsg text-sm-center">
        入力されたメールアドレス、パスワードが正しくないか、利用承認がおりていません。
      </p>
    </div>
    <!-- / -->
    <div class="memberBorderBox py20 pyMd30 pyXl50 px15 pxMd40 pxXl60">
      <b-form name="formMemberLogin"
              v-bind:action="propsPageUrl"
              method="POST">
        <!-- nonce / -->
        <input type="hidden" id="_wpnonce" name="_wpnonce" v-bind:value="propsWpNonce" />
        <input type="hidden" name="_wp_http_referer" v-bind:value="propsPageUrl" />
        <!-- / nonce -->
        <div class="memberInfoBox mx-auto mb30 mbMd20">
          <dl>
            <dt class="memberInfoTtl iconMemberEmail mb5">メールアドレス</dt>
            <dd class="memberInfoData">
              <b-form-input v-validate="{
                              required:true,
                              email:true
                            }"
                            v-model.trim="form.email"
                            type="text"
                            name="email"
                            data-vv-as="メールアドレス"
                            class="textBox"
                            placeholder="例）t_tanaka@example.com">
              </b-form-input>
            </dd>
          </dl>
          <!-- / -->
          <div v-if="veeErrors.first('email')" class="memberInfoBox errMsgBox mx-auto mb25">
            <p class="errMsg">{{veeErrors.first('email')}}</p>
          </div>
          <!-- / -->
        </div>
        <!-- / -->
        <div class="memberInfoBox mx-auto mb30">
          <dl>
            <dt class="memberInfoTtl iconMemberPassword mb5">パスワード</dt>
            <dd class="memberInfoData">
              <b-form-input v-validate="{
                              required:true
                            }"
                            v-model.trim="form.password"
                            type="password"
                            name="password"
                            data-vv-as="パスワード"
                            class="textBox">
              </b-form-input>
            </dd>
          </dl>
          <!-- / -->
          <div v-if="veeErrors.first('password')" class="memberInfoBox errMsgBox mx-auto mb25">
            <p class="errMsg">{{veeErrors.first('password')}}</p>
          </div>
          <!-- / -->
        </div>
        <!-- / -->
        <div class="text-center mb20">
          <b-form-checkbox v-model="form.remember_login"
                           name="remember_login"
                           id="loginRememberCheck">
            ログイン情報を記憶
          </b-form-checkbox>
        </div>
        <!-- / -->
        <div class="text-center">
          <b-button v-bind:disabled="veeErrors.any() || !form.email || !form.password"
                    type="submit"
                    id="btnMemberLogin"
                    variant="outline-primary"
                    class="btnProcedure">
            ログイン<i class="fa fa-angle-right ml-3"></i>
          </b-button>
        </div>
        <!-- / -->
      </b-form>
      <!-- /formMemberLogin -->

      <div class="borderTop mt30 mtMd60 pt20 ptMd30">
        <ul class="d-md-flex justify-content-center fontSize14 mb0 pl0">
          <li class="mb5 mbMd0 mrMd40">
            <a class="txtLink" v-bind:href="propsRootUrl+'/password_apply/'">
              パスワードを忘れた方<i class="fa fa-angle-right ml-3"></i>
            </a>
          </li>
          <li v-if="allow_new_regist">
            <a class="txtLink" v-bind:href="propsRootUrl+'/member_apply/'">
              新規会員登録<i class="fa fa-angle-right ml-3"></i>
            </a>
          </li>
        </ul>
      </div>
      <!-- / -->
    </div>
    <!-- /memberBorderBox -->

  </div>

</template>



<style scoped>
  input[type="text"],input[type="password"] {
    height: 50px;
  }
</style>



<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props: {
          propsSessionExpired: {
            type: Boolean,
            default: false
          },
          propsLoginFailed: {
            type: Boolean,
            default: false
          },
          propsWpNonce: {
            type: String
          },
          propsPageUrl: {
            type: String
          },
          propsRootUrl: {
            type: String
          },
          propsThemeDir: {
            type: String
          }
        },
        data: function() {
          return {
            form: {
              email: null,
              password: null,
              remember_login: false
            },
            allow_new_regist: false
          }
        },
        mounted() {
            console.log('LoginFormComponent mounted.')
        },
        methods: {

        }
    }
</script>
